var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#78d88b",
    d: "M13.27,19.48c-.813,.813-1.27,1.915-1.27,3.065v1.455h1.455c1.15,0,2.252-.457,3.065-1.27l6.807-6.807c.897-.897,.897-2.353,0-3.25-.897-.897-2.353-.897-3.25,0l-6.807,6.807Zm-1.414-1.414l5.067-5.066h-1.922c-1.308-.006-1.307-1.995,0-2h3.978c1.369-1.188,3.513-1.328,5.022-.326v-3.674c0-2.757-2.243-5-5-5H5C2.243,2,0,4.243,0,7v10c0,2.757,2.243,5,5,5h5.027c.126-1.486,.762-2.867,1.829-3.934Zm3.145-11.066h4c1.308,.006,1.307,1.995,0,2h-4c-1.308-.006-1.307-1.995,0-2ZM3,14v-1c-1.308-.006-1.307-1.995,0-2v-1c0-1.654,1.346-3,3-3h2c1.654,0,3,1.346,3,3-.006,1.308-1.995,1.308-2,0,0-.551-.448-1-1-1h-2c-.552,0-1,.449-1,1v1h2c1.308,.006,1.307,1.995,0,2h-2v1c0,.551,.448,1,1,1h2c.552,0,1-.449,1-1,.005-1.308,1.995-1.308,2,0,0,1.654-1.346,3-3,3h-2c-1.654,0-3-1.346-3-3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditSvg);
export default __webpack_public_path__ + "static/media/creditSvg.a8bf872d19809566761691590b41a760.svg";
export { ForwardRef as ReactComponent };